<template>
  <div class="container container--vertical">
    <h1>Art Club Studies</h1>
    <create-study />

    <modal
      :title="modal.study.title"
      :type="modal.type"
      v-model="modal.show"
      @cancelled="modal.show = false"
      @confirm="confirmHandler(modal.study.id, modal.type)"
    >
      <span
        >Are you sure you want to {{ modal.type }}
        {{ modal.study.title }}?</span
      >
    </modal>

    <m-table :headers="table.headers" :items="studies || []" :loading="loading">
      <template #title="{title, id}">
        <router-link
          class="bold"
          :to="{ name: 'admin-study', params: { id } }"
          >{{ title }}</router-link
        >
      </template>

      <template #deadline="{ deadline }">
        <app-date
          class="small"
          format="MMMM D YYYY"
          :date="deadline"
        ></app-date>
      </template>

      <template #createdAt="{ createdAt }">
        <app-date class="small" format="MMMM D YYYY" :date="createdAt" />
      </template>

      <template #published="{ published }">
        <span class="success" v-if="published">Published</span>
        <span class="warning" v-else>Draft</span>
      </template>

      <template #actions="study">
        <drop-down>
          <drop-down-item>
            <router-link
              :to="{ name: 'admin-study', params: { id: study.id } }"
            >
              Edit
            </router-link>
          </drop-down-item>
          <drop-down-item>
            <router-link
              :to="{ name: 'teacher-gallery', params: { id: study.id } }"
            >
              <span>View gallery</span>
              <font-awesome-icon
                class="icon"
                size="sm"
                icon="external-link-alt"
              />
            </router-link>
          </drop-down-item>
          <drop-down-item
            v-if="study.published"
            @click.native="modalHandler(study, 'unpublish')"
          >
            <span class="warning">Unpublish</span>
          </drop-down-item>
          <drop-down-item @click.native="modalHandler(study, 'delete')">
            <span class="error">Delete</span>
          </drop-down-item>
        </drop-down>
      </template>
    </m-table>
  </div>
</template>

<script>
import CreateStudy from '@/components/admin/CreateStudy.vue';
import AppDate from '@/components/app/AppDate';
import MTable from '@/components/global/Table';
import DropDown from '@/components/global/DropDown';
import DropDownItem from '@/components/global/DropDownItem';

import { mapState, mapActions } from 'vuex';

export default {
  name: 'admin-studies',
  components: { CreateStudy, AppDate, MTable, DropDown, DropDownItem },
  data: function() {
    return {
      modal: {
        show: false,
        study: '',
      },
      table: {
        headers: [
          {
            label: 'Study',
            value: 'title',
            align: 'left',
          },
          {
            label: 'Created',
            value: 'createdAt',
            align: 'left',
          },
          {
            label: 'Deadline',
            value: 'deadline',
            align: 'left',
          },
          {
            label: 'Status',
            value: 'published',
            align: 'left',
          },
          {
            label: '',
            value: 'actions',
            align: 'right',
          },
        ],
      },
    };
  },
  methods: {
    ...mapActions('studies', ['getStudies', 'deleteStudy', 'unpublishStudy']),
    modalHandler(study, type) {
      this.modal.show = true;
      this.modal.study = study;
      this.modal.type = type;
    },
    confirmHandler(id, type) {
      if (type === 'delete') {
        this.deleteStudyHandler(id);
      }
      if (type === 'unpublish') {
        this.unpublishStudyHandler(id);
      }
    },
    async deleteStudyHandler(id) {
      await this.deleteStudy(id);
      this.modal.show = false;
      await this.getStudies({
        published: true,
      });
      this.modal.study = '';
    },
    async unpublishStudyHandler(id) {
      await this.unpublishStudy(id);
      this.modal.show = false;
      await this.getStudies();
      this.modal.study = '';
    },
  },
  mounted() {
    this.getStudies({ published: false });
  },
  computed: {
    ...mapState({
      studies: state => state.studies.list,
      loading: state => state.studies.loading,
    }),
  },
};
</script>

<style lang="scss" scoped>
.table .action {
  margin-left: 0.5rem;
  display: inline-flex;
}

.table .date {
  font-size: 0.9rem;
}
</style>
